import React from 'react'
import { useSelector } from 'react-redux';
import { signOut } from "firebase/auth";

const Logout = () => {
  const user = useSelector(state => state.user)
  const userExists = user != null && Object.keys(user).length > 0

  const handleLogout = (e) => {
    e.preventDefault()

    window.location.replace("/logout")
  }

  if (!userExists) return <></>

  return (
    <button className="btn btn-danger logout" onClick={e => handleLogout(e)}>Logout</button>
  )
}

export default Logout
